import ReactECharts from 'echarts-for-react';
import type { EChartsCoreOption } from 'echarts/core';
import React, { useCallback, useMemo, useState } from 'react';
import LazyLoad from 'react-lazyload';
import useChartOptions from './useChartOptions';

const ChartComponent = React.memo(({ options: rawOptions, style = { height: '300px', width: '100%' } }: { options: EChartsCoreOption, style?: React.CSSProperties }) => {
    const [isChartReady, setIsChartReady] = useState(false);
    const options = useMemo(() => rawOptions, [rawOptions]);

    const { options: chartOptions, chartRef } = useChartOptions(options);

    const onChartReady = useCallback((chart: any) => {
        chartRef.current = chart;
        setIsChartReady(true); // Mark chart as ready when initialized
    }, []);

    // Placeholder component
    const Placeholder = () => (
        <div
            style={{
                ...style,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f0f0f0',
                borderRadius: '4px',
            }}
        >
            <span>Loading Chart...</span>
        </div>
    );

    return (
        <LazyLoad
            height={style.height}
            offset={100}
            placeholder={<Placeholder />}
            unmountIfInvisible
        >
            {!isChartReady && <Placeholder />}
            <ReactECharts
                option={chartOptions}
                style={style}
                opts={{ renderer: 'canvas' }}
                onChartReady={onChartReady}
                ref={chartRef}
            />
        </LazyLoad>
    );
});

export default ChartComponent;